// Single source of truth for JS viewport checks. Values mirror the Tailwind 4
// default breakpoints used in classNames (md:/lg:) so JS and CSS never disagree.
export const BREAKPOINTS = {
  md: 768,
  lg: 1024,
} as const

export type Breakpoint = keyof typeof BREAKPOINTS

/** True when the viewport is at or above the given breakpoint. SSR-safe (false on server). */
export function isAtLeast(bp: Breakpoint): boolean {
  if (typeof window === 'undefined') return false
  return window.matchMedia(`(min-width: ${BREAKPOINTS[bp]}px)`).matches
}

/** True when the viewport is below the given breakpoint. SSR-safe (false on server). */
export function isBelow(bp: Breakpoint): boolean {
  if (typeof window === 'undefined') return false
  return !window.matchMedia(`(min-width: ${BREAKPOINTS[bp]}px)`).matches
}
